export default __webpack_public_path__ + "static/media/android-launchericon-192-192.53b55d48.png";